import React from 'react';
import { ChevronDown } from 'lucide-react';
import { INLINE } from '../generated/inlineImages';
import { REGISTRATION_FORM_URL } from '../constants/links';
import CivicButton from './CivicButton';
import NoticeStrip from './NoticeStrip';
import './Header.css';

interface HeaderProps {
  logo: string;
}

const Header: React.FC<HeaderProps> = ({ logo: _logo }) => {
  return (
    <header id="inicio" className="header">
      <div
        className="header__photo"
        style={{ backgroundImage: `url(${INLINE.home})` }}
        aria-hidden="true"
      />
      <div className="header__overlay" aria-hidden="true" />

      <div className="header__container">
        <div className="header__content">
          <NoticeStrip />
          <p className="header__kicker">Organizado por Una Voz Diferente</p>
          <img
            src={INLINE.logohero}
            alt="II Cumbre Nacional de Cristianos Políticos — Lima 2026"
            className="header__logo"
          />
          <div className="header__actions">
            <CivicButton
              href={REGISTRATION_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              size="large"
            >
              Inscríbete aquí
            </CivicButton>
          </div>
        </div>
      </div>

      <a href="#quienes-somos" className="header__scroll-hint" aria-label="Ir a Quiénes Somos">
        <ChevronDown size={22} aria-hidden="true" />
      </a>
    </header>
  );
};

export default Header;
